import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';

export default function HeroSection() {
  const featuredMovies = movies.filter((m) => m.featured).slice(0, 5);

  return (
    <section className="relative w-full h-[520px] md:h-[650px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20interior%20with%20red%20velvet%20curtains%20and%20dramatic%20stage%20lighting%2C%20warm%20golden%20spotlights%2C%20elegant%20theater%20atmosphere%2C%20classic%20cinema%20aesthetic%2C%20deep%20red%20and%20dark%20brown%20tones%2C%20luxurious%20and%20grand%20composition%2C%20professional%20photography&width=1920&height=1080&seq=hero-bg-cinema&orientation=landscape"
          alt="屁屁影院 - 高清影视在线观看平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
          屁屁影院
          <span className="block text-xl md:text-2xl lg:text-3xl font-body font-light mt-2 text-white/80">
            高清影视在线观看平台
          </span>
        </h1>
        <p className="text-sm md:text-base text-white/60 max-w-2xl mb-8 leading-relaxed">
          汇聚全球热门电影、电视剧、动漫资源，画质清晰、更新及时，随时随地享受极致观影体验
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/movie"
            className="px-8 py-3 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-play-circle-line mr-2"></i>
            立即观影
          </Link>
          <Link
            to="/category/anime"
            className="px-8 py-3 bg-white/10 backdrop-blur-sm text-white border border-white/20 rounded-full font-medium text-sm hover:bg-white/20 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-emotion-line mr-2"></i>
            热门动漫
          </Link>
        </div>

        <div className="flex items-center gap-6 mt-10">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">10,000+</div>
            <div className="text-xs text-white/50 mt-1">影视资源</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">500万+</div>
            <div className="text-xs text-white/50 mt-1">日活用户</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">1080P+</div>
            <div className="text-xs text-white/50 mt-1">高清画质</div>
          </div>
        </div>
      </div>
    </section>
  );
}